import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import { FormContext } from "../Muiltiforms";
import * as yup from "yup";
import FormikControl from '../../../../hoc/formikComponents/FormikControl.js'

function Basic() {
  const { activeStepIndex, setActiveStepIndex, formData, setFormData } =
    useContext(FormContext);

  const renderError = (message) => (
    <p className="italic text-red-600">{message}</p>
  );

  const ValidationSchema = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
  });

  return (
    <Formik
    //   initialValues={{
    //     name: "",
    //     email: "",
    //   }}
      //validationSchema={ValidationSchema}
      onSubmit={(values) => {
        const data = { ...formData, ...values };
        setFormData(data);
        setActiveStepIndex(activeStepIndex + 1);
      }}
    >
         <Form className="flex flex-col justify-center items-center">
    <div>
        <p>basic Info</p>
    <button
          className="rounded-md bg-indigo-500 font-medium text-white my-2 p-2"
          type="submit"
        >
          Continue
        </button>
        </div>
        </Form>
        </Formik>
  );
}

export default Basic;